import { useCallback, useState } from "react";

/**
 * The current page of a server-paged list, tied to its filters: whenever
 * `filtersKey` changes the page is 1 again — in the same render, so the list
 * is fetched once, for page 1. Pass something that changes with every filter,
 * e.g. `JSON.stringify(filters)`.
 */
export function usePage(filtersKey: string): [number, (page: number) => void] {
  const [state, setState] = useState({ key: filtersKey, page: 1 });
  const page = state.key === filtersKey ? state.page : 1;
  const setPage = useCallback((next: number) => setState({ key: filtersKey, page: next }), [filtersKey]);
  return [page, setPage];
}
